import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';
const { persistAtom } = recoilPersist();
export const carLatState = atom({
    key: 'carLatState',
    default: {},
    effects_UNSTABLE: [persistAtom],
});
export const editbtn = atom({
    key: 'editbtn',
    default: false,
    effects_UNSTABLE: [persistAtom],
});
export const rolSkillLearnId = atom({
    key: 'rolSkillLearnId',
    default: false,
    effects_UNSTABLE: [persistAtom],
}); 
export const otherDivData = atom({
    key: 'otherDivData',
    default: false,
    effects_UNSTABLE: [persistAtom],
}); 